import {
GET_DROPSHIP_FEED_REQUEST,
GET_DROPSHIP_FEED_SUCCESS,
GET_DROPSHIP_FEED_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";


export const getDropshipFeedReport = (token, values) => (dispatch) => {
  dispatch({ type: GET_DROPSHIP_FEED_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/DropshipFeedReport`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: { ...values },
  })
    .then((response) => {
      return dispatch({
        type: GET_DROPSHIP_FEED_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_DROPSHIP_FEED_ERROR,
        payload: [],
      });
    });
};

